import {
  NotepadContentAgendaStep,
  ResourcesAgendaStep,
  TeamCoherenceReview,
  TeamLoopsAgendaStep,
  TeamMetricsAgendaStep,
  TeamStrategicMapReview,
  TeamStructureReview,
  TeamTasksAgendaStep,
  UserLoopsAgendaStep,
  UserRolesAgendaStep,
  UserStrategicOwnershipAgendaStep,
  UserTasksAgendaStep,
} from ".";
import { MeetingAgendaItemType, MeetingType } from "../../../constants";
import { GetOneOnOneMeetingDto, GetTeamMeetingDto, MeetingAgendaItemDto } from "../../../http";
import { UserFeedbackAgendaStep } from "./UserFeedbackAgendaStep";
interface IProps {
  agendaStep: MeetingAgendaItemDto;
  meeting: GetOneOnOneMeetingDto | GetTeamMeetingDto;
}

const MeetingAgendaStepContent = (props: IProps) => {
  function renderAgendaStep() {
    switch (props.agendaStep.type) {
      case MeetingAgendaItemType.Blank:
        return null;
      case MeetingAgendaItemType.Notepad:
        return <NotepadContentAgendaStep agendaStepGuid={props.agendaStep.guid} />;
    }

    if (props.meeting.type === MeetingType.OneOnOne) {
      switch (props.agendaStep.type) {
        case MeetingAgendaItemType.UserStrategicOwnership:
          return <UserStrategicOwnershipAgendaStep userGuid={props.meeting.otherUser.userId} />;
        case MeetingAgendaItemType.UserTasks:
          return <UserTasksAgendaStep userGuid={props.meeting.otherUser.userId} />;
        case MeetingAgendaItemType.UserRoles:
          return <UserRolesAgendaStep userGuid={props.meeting.otherUser.userId} />;
        case MeetingAgendaItemType.UserLoops:
          return <UserLoopsAgendaStep userGuid={props.meeting.otherUser.userId} />;
        case MeetingAgendaItemType.UserFeedback:
          return <UserFeedbackAgendaStep meeting={props.meeting} />;
        default:
          return null;
      }
    } else if (props.meeting.type === MeetingType.Team) {
      switch (props.agendaStep.type) {
        case MeetingAgendaItemType.TeamTasks:
          return <TeamTasksAgendaStep teamSlug={props.meeting.team.slug} />;
        case MeetingAgendaItemType.TeamLoops:
          return <TeamLoopsAgendaStep teamSlug={props.meeting.team.slug} />;
        case MeetingAgendaItemType.TeamMetrics:
          return <TeamMetricsAgendaStep teamSlug={props.meeting.team.slug} />;
        case MeetingAgendaItemType.TeamStrategy:
          return <TeamStrategicMapReview teamName={props.meeting.team.name} teamSlug={props.meeting.team.slug} />;
        case MeetingAgendaItemType.TeamStructureReview:
          return <TeamStructureReview teamSlug={props.meeting.team.slug} />;
        case MeetingAgendaItemType.TeamCoherenceReview:
          return <TeamCoherenceReview teamSlug={props.meeting.team.slug} />;
        case MeetingAgendaItemType.Resources:
          return <ResourcesAgendaStep agendaStepGuid={props.agendaStep.guid} agendaStepName={props.agendaStep.name} />;
        default:
          return null;
      }
    }

    return null;
  }

  return renderAgendaStep();
};

export { MeetingAgendaStepContent };
